import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { Login } from '../login/login';

@Injectable({
  providedIn: 'root'
})
export class LeadIndicadorService {
  url: string;
  token: any;

  constructor(
    private http: HttpClient,
    private configService: ConfigService
  ) { 
    this.url = configService.getURL() + 'indicador/leads';
    this.token = new Login();
  }

  totalLeads(){
    return this.http.get<Object[]>(this.url + '/total', {
        headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
      });
  }

  novosLeads(){
    return this.http.get<Object[]>(this.url + '/novos-leads', {
        headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
      });
  }

  historicoTotalLeads(qtdRegistros: any = 12){
    return this.http.get<Object[]>(this.url + '/historico/total-leads?qtdRegistros=' + qtdRegistros, {
        headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
      });
  }
  historicoNovosLeads(qtdRegistros: any = 12){
    return this.http.get<Object[]>(this.url + '/historico/novos-leads?qtdRegistros=' + qtdRegistros, {
        headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
      });
  }
}
